/* istanbul ignore file */

export { default } from "./AinoChatButton";
